import { toast } from 'bulma-toast'

/**
 * bulma-toast's package.json points at an index.d.ts it does not ship, so the
 * options shape is declared here rather than imported.
 */
interface ToastOptions {
  message?: string
  type?: string
  position?: string
  dismissible?: boolean
  closeOnClick?: boolean
  duration?: number
  single?: boolean
  [key: string]: unknown
}

type ExtraConfig = Partial<ToastOptions>

const defaults: ExtraConfig = {
  type: 'is-info',
  position: 'top-center',
  dismissible: true,
  closeOnClick: false,
  duration: 7000,
  single: true,
}

const notify = (message: string, extraConfig: ExtraConfig = {}): void => {
  const config: ToastOptions = { ...defaults, ...extraConfig }
  config.message = message
  config.type = `${config.type} custom-width`
  toast(config as never)
}

const success = (message: string, extraConfig: ExtraConfig = {}) =>
  notify(message, { ...extraConfig, type: 'is-success' })

const warning = (message: string, extraConfig: ExtraConfig = {}) =>
  notify(message, { ...extraConfig, type: 'is-warning' })

const error = (message: string, extraConfig: ExtraConfig = {}) =>
  notify(message, { ...extraConfig, type: 'is-danger' })

const fatalError = (err: unknown): void => {
  console.log(err)
  notify(
    'Something went wrong, please try again, if the problem persists call the system administrator',
    { type: 'is-danger' },
  )
}

export { notify, success, warning, error, fatalError }
export default { notify, success, warning, error, fatalError }
